import buybackConfig from './buybackConfig';
import channelsConfig from './channelsConfig';
import inventoryConfig from './inventoryConfig';
import logisticsConfig from './logisticsConfig';
import operationsConfig from './operationsConfig';
import { IProductConfig } from './Products.types';
import supplyConfig from './supplyConfig';

const productsConfig: IProductConfig[] = [
  inventoryConfig,
  logisticsConfig,
  operationsConfig,
  supplyConfig,
  channelsConfig,
  buybackConfig,
];

export default productsConfig;
